// Filename: uicanvasstage.js
// Timestamp: 2018.01.21-20:13:22 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

import gnnodexui from '@bumblehead/gani/src/gnnodexui.js'
import uicanvasstageseq from './uicanvasstageseq.js'

import {
  gnnodeChildKeysGet as nodeChildKeysGet
} from '@bumblehead/gani/src/gnnode.js'

import {
  gnnodeosxGet as nodeosxGet
} from '@bumblehead/gani/src/gnnodeos.js'

import {
  gnpublish_subj
} from '@bumblehead/gani/src/gnpublish.js'

import {
  gnaccSubj as accSubj
} from '@bumblehead/gani/src/gnacc.js'

const addtosceneseqactions = (ss, cfg, gr, nd, scenecfg) => {
  return nodeChildKeysGet(nd).reduce((scenecfg, ckey/*, i*/) => (
    uicanvasstageseq.addtoscene(
      ss, cfg, gr, gr.get(ckey), uicanvasstageseq, scenecfg)
  ), scenecfg)
}

// calculate objects intersecting the picking ray
const getintersecting = (ss, cfg, gr, nd, rafcfg) => {
  let { raycaster, camera, mouse, glscene } = rafcfg

  // do not find objects w/ dis-engaged mouse
  if (typeof mouse.x === 'number' &&
    typeof mouse.y === 'number')
    raycaster.setFromCamera(mouse, camera)

  return raycaster.intersectObjects(glscene.colliders)[0]
}

const getintersectingobject = (ss, cfg, gr, nd, rafcfg) => {
  const intersecting = getintersecting(ss, cfg, gr, nd, rafcfg)

  return intersecting && intersecting.object
}

const onmesheventfn = evname => (ss, cfg, gr, nd, rafcfg, mesh) => {
  const meshnode = mesh && gr.get(mesh.nodekey)
  const meshnodeui = meshnode && nodeosxGet(cfg, gr, meshnode)
  const meshnodeuihandler = meshnodeui && (
    meshnodeui[evname] || meshnodeui['x' + evname])

  if (meshnodeuihandler)
    meshnodeuihandler(
      ss, cfg, gr, meshnode,
      gnnodexui.prevget(cfg, meshnode), accSubj.get(meshnode), rafcfg, mesh)
}

const onclickmesh = onmesheventfn('onclick')
const onclickupmesh = onmesheventfn('onclickup')
const onrayoverstartmesh = onmesheventfn('onrayoverstart')
const onrayoverendmesh = onmesheventfn('onrayoverend')
const onrayoutmesh = onmesheventfn('onrayout')
const onrayovermesh = onmesheventfn('onrayover')

// ray **is not** intersecting a mesh
const onintersectnone = (ss, cfg, gr, nd, subj) => {
  if (subj.lastmesh) {
    onrayoutmesh(ss, cfg, gr, nd, subj, subj.lastmesh)

    subj.lastmesh = null
  }
}

// ray **is** intersecting a mesh
const onintersectmesh = (ss, cfg, gr, nd, rafcfg, mesh) => {
  const lastmesh = rafcfg.lastmesh
  const lastmeshnodekey = lastmesh && lastmesh.nodekey
  const meshnodekey = mesh && mesh.nodekey

  if (meshnodekey && gr.has(meshnodekey)) {
    if (lastmeshnodekey === meshnodekey) {
      onrayoutmesh(ss, cfg, gr, nd, rafcfg, lastmesh)
    }

    onrayovermesh(ss, cfg, gr, nd, rafcfg, mesh)

    rafcfg.lastmesh = mesh
  }
}

const publishintersect = (sess, cfg, graph, meshnodekey, { x, y }, fn) => (
  gnpublish_subj(sess, cfg, meshnodekey, { pos: [ x, y, -200 ] }, fn))

const raycheck = (ss, cfg, gr, nd, pg, rafcfg) => {
  let ismouseintersecting = Boolean(rafcfg.ismouseintersecting),
      ismousechangeddown = Boolean(rafcfg.ismousechangeddown),
      ismousechangedup = Boolean(rafcfg.ismousechangedup),
      ismousedown = Boolean(rafcfg.ismousedown),
      { raycaster,
        videomesh } = rafcfg,
      parentpos,
      intersectobj,
      intersectpoint,
      mesh = rafcfg.glscene &&
      getintersectingobject(ss, cfg, gr, nd, rafcfg)

  if (mesh) {
    if (ismousechangeddown) {
      ismouseintersecting = true

      onclickmesh(ss, cfg, gr, nd, rafcfg, mesh)
    }

    if (ismouseintersecting &&
        // !ismousechangedup &&
        mesh.draggable) {
      if (ismousechangedup) {
        [ intersectobj ] = raycaster.intersectObject(videomesh)

        mesh.scale.set(1, 1, 1)

        // eslint-disable-next-line no-useless-assignment
        ismouseintersecting = false

        if (intersectobj) {
          parentpos = mesh.parent.position
          intersectpoint = intersectobj.point

          parentpos.setX(intersectpoint.x)
          parentpos.setY(intersectpoint.y)

          publishintersect(
            ss, cfg, gr, mesh.nodekey, intersectpoint, (err, gr) => {
              onclickupmesh(ss, cfg, gr, gr.get(nd.get('key')), rafcfg, mesh)
            })
        }
      }

      if (ismousedown) {
        [ intersectobj ] = raycaster.intersectObject(videomesh)

        mesh.scale.set(5, 5, 5)

        if (intersectobj) {
          parentpos = mesh.parent.position
          intersectpoint = intersectobj.point

          parentpos.setX(intersectpoint.x)
          parentpos.setY(intersectpoint.y)

          if (!rafcfg.publishthrottle) {
            rafcfg.publishthrottle = cfg.lockfnthrottling({
              isendthrottlecall: false,
              ms: 400
            }, pg.publish)
          }

          rafcfg.publishthrottle(ss, cfg, mesh.nodekey, intersectpoint)
        }
      }
    }

    if (rafcfg.INTERSECTED !== mesh) {
      if (rafcfg.INTERSECTED)
        onrayoverendmesh(ss, cfg, gr, nd, rafcfg, rafcfg.INTERSECTED)

      rafcfg.INTERSECTED = mesh
      rafcfg.INTERSECTEDTS = Date.now()

      onrayoverstartmesh(ss, cfg, gr, nd, rafcfg, mesh)
    }
    onintersectmesh(ss, cfg, gr, nd, rafcfg, mesh)
  } else {
    if (rafcfg.INTERSECTED) {
      onrayoverendmesh(ss, cfg, gr, nd, rafcfg, rafcfg.INTERSECTED)
    }
    // eslint-disable-next-line no-useless-assignment
    ismouseintersecting = false
    rafcfg.INTERSECTED = null
    onintersectnone(ss, cfg, gr, nd, rafcfg)
  }

  rafcfg.ismousechangeddown = false
  rafcfg.ismousechangedup = false
}

const xonframe = (ss, cfg, gr, nd, pg, prev) => {
  gnnodexui.updatechildseq(ss, cfg, gr, nd, prev)

  raycheck(ss, cfg, gr, nd, pg, prev)
  gnnodexui.render(prev)
}

const updatechildseq = (ss, cfg, gr, nd, rafcfg) => {
  const timess_current = rafcfg.buf_timess_current || 0

  nodeChildKeysGet(nd).reduce((gr, ckey/*, i*/) => {
    const cnode = gr.get(ckey)

    uicanvasstageseq.onrender(
      ss, cfg, gr, cnode, gnnodexui.prevget(cfg, cnode), rafcfg, timess_current)

    return gr
  }, gr)
}

const onstagemousedown = (ss, cfg, gr, nd, rafcfg) => {
  rafcfg.ismousechangeddown = Boolean(rafcfg.ismouseup)
  rafcfg.ismousedown = true
  rafcfg.ismouseup = false
}

const onstagemouseup = (ss, cfg, gr, nd, rafcfg) => {
  rafcfg.ismousechangedup = Boolean(rafcfg.ismousedown)
  rafcfg.ismousedown = false
  rafcfg.ismouseup = true
}

const initialstagestate = (ss, cfg, gr, nd, rafcfg) => {
  rafcfg.ismousechangeddown = false
  rafcfg.ismousechangedup = false
  rafcfg.ismousedown = false
  rafcfg.ismouseup = true

  return rafcfg
}

export default {
  addtosceneseqactions,
  getintersecting,
  getintersectingobject,
  onmesheventfn,
  onclickmesh,
  onclickupmesh,

  onrayoverstartmesh,
  onrayoverendmesh,
  onrayoutmesh,
  onrayovermesh,
  onintersectnone,
  onintersectmesh,
  publishintersect,
  raycheck,
  xonframe,
  updatechildseq,
  onstagemousedown,
  onstagemouseup,
  initialstagestate
}
